import { render, staticRenderFns } from "./main.vue?vue&type=template&id=081d54d9&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081d54d9')) {
      api.createRecord('081d54d9', component.options)
    } else {
      api.reload('081d54d9', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=081d54d9&", function () {
      api.rerender('081d54d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/project/main.vue"
export default component.exports